import { http } from "@/http/axios.js";
import { dateFormat } from "@/utils/index.js";
import { exportData } from "@/utils/export.js";

// 获取今日待跟进账单列表
export function getListAPI(params) {
  return http({
    url: "/admin/orderBill/follow/day/page",
    method: "get",
    params,
  });
}

// 添加跟进记录
export function addFollowUpRecordAPI(data) {
  return http({
    url: "/admin/order/bill/followUp/add",
    method: "post",
    data,
  });
}

// 完成跟进
export function completeFollowUpAPI(data) {
  return http({
    url: "/admin/orderBill/follow/day/finish",
    method: "post",
    data,
  });
}

// 获取跟进记录列表
export function getFollowUpRecordListAPI(params) {
  return http({
    url: "/admin/order/bill/followUp/list",
    method: "get",
    params,
  });
}

// 账单搜索
export function searchBillAPI(params) {
  return http({
    url: "/admin/orderBill/follow/search",
    method: "get",
    params,
  });
}

// 导出
export function exportAPI(data) {
  exportData(
    "/api/admin/orderBill/follow/day/export",
    data,
    `OK租机今日待跟进账单${dateFormat()}.xlsx`,
  );
}
